
// @ts-nocheck
// This file is auto-generated. Do not edit manually.
export const actionsMap = {

};
